import {
  Comment,
  SimpleUser,
  ObjectIdAsHexString,
} from "kreate-common/modules/business-types";
import { z } from "zod";

export const Params = z.object({
  targetId: ObjectIdAsHexString,
  type: z.enum(["artwork", "collection"]).default("artwork"),
  replyTo: ObjectIdAsHexString.optional(), // to get comments that reply to a specific comment
  offset: z.coerce.number().gte(0).optional().default(0),
  limit: z.coerce.number().lte(100).optional().default(25),
});

export type Params = z.infer<typeof Params>;

export const CommentResult = Comment.extend({
  author: SimpleUser.nullish(),
  // extra reply to document, if it is `undefined` and `replyTo` is not,
  // then we got case `Original message was deleted` like in discord
  replyToDoc: z.any().nullish(),
});

export type CommentResult = z.infer<typeof CommentResult>;

export const Result = z.object({
  comments: CommentResult.array(),
  count: z.number(),
});

export type Result = z.infer<typeof Result>;

export type GetComments$Params = Params;
export const GetComments$Params = Params;
export type GetComments$Result = Result;
export const GetComments$Result = Result;
